import { FormField as FieldType } from './types';
import Field from './Field';
import React from 'react';

const Fields = ({ fields = [] }: { fields: FieldType[] }) =>
  fields.map((field) => <Field {...field} key={field.name} />);

export default Fields;
